import { forwardRef } from 'react';
import { clsx } from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  tiny?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  function Input(
    {
      className,
      tiny = false,
      ...props
    },
    ref
  ) {
    return (
      <input
        ref={ref}
        {...props}
        className={clsx(
          // Base styles (équivalent à .inputBase)
          "w-full px-4 py-4 rounded border border-gray-300 text-sm font-normal text-gray-700 box-border",
          "placeholder:text-gray-500 placeholder:italic",
          "focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary",
          // Hauteur par défaut (52px)
          "h-12",
          // Variant tiny (40px height)
          tiny && "!h-10",
          className
        )}
      />
    );
  }
);
